import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagBE(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURf/POvEuPf/NNREREfc3Rv1AThkZGf/MMB8fHyQkJCPqRdYAAAGaSURBVDjL1Y+xboMwFEURXxAkPgB58R4kWINk7x3ID4BkefbCijIgsnWkf9t7n4mbSkHqUFXqTR4ezvF9kH2kvGcp15S37H8J24FwTzkS5Pa2rvf5tbDGbNs2H65YtzudOaty/vF40UAhJ8dUed9fbZyvFRBAcxaggRT8ai9PDTdcBawqhYbeWo59XnHLyORFQHA7NiyrX2WWmVRGmb431vTWcMWyeA/D8ytUDsoGGNiA5yVzHlmhuUGpeF8pMIMKaSB3jtqAbyDFAWqjgXfY4zwaeJ2S6aUBwYo9XlbIApWbB6eweOdFGSKu+BUpqcE7adjzQnC/L3SmLLuuE6EZXYPfkwACw5RsaJrIx3FQWoWA0aqM9w0bRjeSomcIMPYGckxZnqQBqevxDI77kw4TVrABwxV1E6VB+oPWWFE8lNSA40zMqABOp+CKeqzZgeMcUK/FKgtwvEHRnTJyUBztg0+avEC6Ag3CaxytlhfkCMSWgisiR1oglmD2gtiQ0k6ITg0x3wQlmHMgoCBMkmNBtuhjQU8/afhz4RM3XYDMFPoNigAAAABJRU5ErkJggg==",
    alt: "BE"
  }, props));
}